import tagTester from './_tagTester.js';

export default tagTester('Error');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isError.js
// module id = 942
// module chunks = 0